import { fetchData } from "./fetch";

export const dismissMessage = (id) => fetchData('POST', `/messages/${id}/dismiss`);
